// using string accessor fixes error with "Error: Cannot find symbol for node: NODE_ENV"
// eslint-disable-next-line dot-notation
const isProduction = () => process.env['NODE_ENV'] === 'production';

export default isProduction;
